export default (api) => ({
  getEnvData: () => api.get('/env')
})
